import type { ChatMessageId, IsoDateTimeString } from './common';

export const ChatUserType = {
  Unknown: 'Unknown',
  Caller: 'Caller',
  Dispatcher: 'Dispatcher',
} as const;
export type ChatUserType = (typeof ChatUserType)[keyof typeof ChatUserType];

export const EmergencySituationInstructions = {
  None: 'None',
  Cpr: 'Cpr',
  Choking: 'Choking',
  Unconsciousness: 'Unconsciousness',
  Bleeding: 'Bleeding',
  Nosebleeds: 'Nosebleeds',
  GpsInstructionsIos: 'GpsInstructionsIos',
  GpsInstructionsAndroid: 'GpsInstructionsAndroid',
  CameraInstructionsIos: 'CameraInstructionsIos',
  CameraInstructionsAndroid: 'CameraInstructionsAndroid',
  ChildChoking: 'ChildChoking',
} as const;
export type EmergencySituationInstructions =
  (typeof EmergencySituationInstructions)[keyof typeof EmergencySituationInstructions];

export type ChatMessage = {
  id: ChatMessageId;
  sentTimeUtc: IsoDateTimeString;
  userType: ChatUserType;
  message: string | null;
  emergencySituationInstructions: EmergencySituationInstructions;
  attachedImageUrl: string | null;
};

export type AttachmentBody = {
  mimeType: string;
  fileData: string;
};

export const SnapshotChunkType = {
  Start: 'Start',
  Chunk: 'Chunk',
  End: 'End',
} as const;
export type SnapshotChunkType = (typeof SnapshotChunkType)[keyof typeof SnapshotChunkType];

export type SnapshotChunkMessage = {
  snapshotId: string;
  type: SnapshotChunkType;
  mimeType: string | null;
  chunkData: string | null;
  senderType: ChatUserType;
};

export const CallerConnectedStatus = {
  NotConnectedYet: 'NotConnectedYet',
  Connected: 'Connected',
  Disconnected: 'Disconnected',
} as const;
export type CallerConnectedStatus = (typeof CallerConnectedStatus)[keyof typeof CallerConnectedStatus];

export const WebAppState = {
  None: 'None',
  WebAppSmsSent: 'WebAppSmsSent',
  LocationSmsSent: 'LocationSmsSent',
  AppOpened: 'AppOpened',
  LocationPermissionRequested: 'LocationPermissionRequested',
  LocationPermissionGranted: 'LocationPermissionGranted',
  LocationUnavailableNotSupported: 'LocationUnavailableNotSupported',
  LocationPermissionDenied: 'LocationPermissionDenied',
  LocationPositionUnavailable: 'LocationPositionUnavailable',
  LocationTimeout: 'LocationTimeout',
  CameraPermissionRequested: 'CameraPermissionRequested',
  CameraPermissionGranted: 'CameraPermissionGranted',
  CameraPermissionRejected: 'CameraPermissionRejected',
  UnsupportedBrowser: 'UnsupportedBrowser',
  StartingVideoTransmission: 'StartingVideoTransmission',
  VideoTransmissionActive: 'VideoTransmissionActive',
  VideoTransmissionFailed: 'VideoTransmissionFailed',
} as const;
export type WebAppState = (typeof WebAppState)[keyof typeof WebAppState];
